<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Daily Accounts Statement</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-data-table
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="accountsData"
            >
              <template v-slot:item.salesPayments="{ item }">{{ item.salesPayments.toLocaleString() }}</template>
              <template v-slot:item.dailyExpenses="{ item }">{{ item.dailyExpenses.toLocaleString() }}</template>
              <template v-slot:item.withdrawals="{ item }">{{ item.withdrawals.toLocaleString() }}</template>
              <template v-slot:item.deposits="{ item }">{{ item.deposits.toLocaleString() }}</template>
              <template v-slot:item.atHand="{ item }">
                <span v-if="item.accountType == 'F'">{{ item.accountBalance }}</span>
                <span v-else>{{ item.atHand.toLocaleString() }}</span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn color="accent" text v-if="item.accountType == 'F'" @click="openModal(item)"><v-icon left>mdi-closed-caption</v-icon>Close Account</v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-row>
          <!-- Outsourced dialog -->
        <v-dialog v-model="dialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="primary" dark>
              <v-toolbar-title>Close Account</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid class="subtitle-2 text--primary">
                <v-row>
                  <v-col cols="12" xs="12" md="4">
                    <v-text-field
                      v-model="closingItem.account"
                      readonly
                      filled
                      label="Name"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <v-text-field
                      v-model="closingItem.accountBalance"
                      label="Available Amount"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" md="4">
                    <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="accent" @click="closeAccount" :loading="loader">
                      <v-icon left>mdi-content-save</v-icon> Save
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of outsourced modal-->

        </v-row>
      </v-card-text>
    </v-card>

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      accountsData: [],
      closingItem: {},
      dialog: false,
      loader: false,
      pageItems: 100,
      DocDate: null,
      date: new Date().toISOString().substr(0, 10),
      headers: [
        { text: "Account", value: "account" },
        { text: "Sales Payments", value: "salesPayments" },
        { text: "Deposits", value: "deposits" },
        { text: "Withdrawals", value: "withdrawals" },
        { text: "Expenses", value: "dailyExpenses" },
        { text: "At Hand", value: "atHand" },
        { text: "Action", value: "action" },
      ],
    };
  },
  methods: {
    setDate(date) {
      this.DocDate = date;
    },
    openModal(data) {
      this.closingItem = data;
      this.dialog = true;
    },
    closeAccount() {
      const url = "/close-account";
      const dataItem = this.closingItem;
      const data = {
        AccountId: dataItem.accountId,
        Amount: dataItem.accountBalance,
        DocDate: this.DocDate
      };
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            location.reload();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRecords() {
      const data = {
        StartDate: null,
        EndDate: null,
      };
      const url = "/accounts/statement";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accountsData = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getRecords();
  },
};
</script>

<style lang="scss" scoped>
</style>